import React from 'react';
import { PageSection } from './SubPageParts';

/** Shared shell for the legal documents: title, then prose sections. */
export const LegalBody = ({ title, children }) => (
  <PageSection className="pt-8 pb-6">
    <h1 className="text-[30px] font-bold text-black md:text-[40px]">{title}</h1>
    <div className="mt-8 max-w-[900px] space-y-10">{children}</div>
  </PageSection>
);

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="text-[20px] font-bold text-black md:text-[24px]">{heading}</h2>
    <div className="mt-3 space-y-4 text-[15px] leading-relaxed text-black/85 md:text-[17px]">
      {children}
    </div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="mt-2 space-y-2">
    {items.map((item) => (
      <li key={typeof item === 'string' ? item : item.term} className="flex gap-3">
        <span aria-hidden="true" className="mt-[9px] h-1.5 w-1.5 flex-shrink-0 rounded-full bg-black/60" />
        <span>
          {typeof item === 'string' ? (
            item
          ) : (
            <>
              <strong className="font-semibold text-black">{item.term}</strong> &mdash; {item.body}
            </>
          )}
        </span>
      </li>
    ))}
  </ul>
);
